import { render, staticRenderFns } from "./advertCreat.vue?vue&type=template&id=67b89f7c&scoped=true"
import script from "./advertCreat.vue?vue&type=script&lang=js"
export * from "./advertCreat.vue?vue&type=script&lang=js"
import style0 from "./advertCreat.vue?vue&type=style&index=0&id=67b89f7c&prod&lang=scss"
import style1 from "./advertCreat.vue?vue&type=style&index=1&id=67b89f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b89f7c",
  null
  
)

export default component.exports